import { defineComponent } from "vue";

export default defineComponent({
    template: `
        <div>
            <div v-if="accepted == null" class="ConsentDialog">
                <div class="ConsentDialog__inner">
                    <div class="ConsentDialog__question">{{ question }}</div>

                    <div class="ConsentDialog__buttons">
                        <button type="button" class="button button--10 button--yes" @click="onClickAccept">Tak</button>
                        <button type="button" class="button button--10 button--no" @click="onClickCancel">Nie</button>
                    </div>
                </div>
            </div>

            <template v-else>
                <slot v-if="accepted"></slot>

                <template v-else>
                    <div class="ConsentDialog__cancel" v-html="cancel_html"></div>

                    <div class="ConsentDialog__buttons">
                        <button type="button" class="button button--10" @click="onClickReset">Zmień wybór</button>
                    </div>
                </template>
            </template>
        </div>
    `,

    emits: [
        'update:accepted',
        'accept',
        'cancel',
        'reset',
    ],

    props: {
        question: { type: String, required: true },
        accepted: { type: Boolean },

        cancel_html: { type: String },
    },

    methods: {
        onClickAccept() {
            this.$emit('update:accepted', true);
            this.$emit('accept');
        },

        onClickCancel() {
            this.$emit('update:accepted', false);
            this.$emit('cancel');
        },

        onClickReset() {
            this.$emit('update:accepted', null);
            this.$emit('reset');
        },
    },
});
